
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/SetPassword.css";
import validateForm from "../utils/Validation";
import { useDispatch, useSelector } from "react-redux";
import { GET_USER_FORGOT_EMAIL_REQUEST } from "../store/Actions/Actions";

function ForgotPassword() {

  const [formErrors,setFormErrors]=useState({})
  const dispatch = useDispatch();
  const isLoading = useSelector(_=>_?.forgotPassword?.isLoading)

const onFormSubmit=(e)=>{
  e.preventDefault();

  const formData = e.target;
  const payload = {email:formData.email.value}
   const requiredFields = ["email"];
      const errors = validateForm(payload, requiredFields);
      setFormErrors(errors);

      if (Object.keys(errors).length > 0) {
        return;
      }

  dispatch({type:GET_USER_FORGOT_EMAIL_REQUEST,payload});

}




  return (
    <div className="set-password-container">
      <div className="header move-top forgot-password-header">
        <Link to="/"><img src="../assets/images/logo.png" alt="Logo" className="logo" /></Link>
        <h2 className="mb-4 text-center fw-lighter text-body-secondary">
          Forgot Password
        </h2>
      </div>

      <div className="password-form-1">
        <p className="subtitle">Please Enter Your Email Address.</p>

        <form className="budget-form" onSubmit={onFormSubmit}>
          <div className={`form-group flex-item ${formErrors.email ? 'has-error' : ''}`}>

            <label className="form-label fw-lighter">Email Address</label>
            <input
              className="form-control"
              type="email"

              name="email"
              placeholder="Email"
            />
          </div>

           {formErrors?.email && <div className="alert" role="alert">
            {formErrors?.email}
                </div>}

                
           {/* {FormReduxData?.error && <div className="alert" role="alert">
                 Something went wrong! Please try again in a moment.
                </div>} */}
         

         
          <button className="btn btn-primary w-100 mt-3" type="submit">
            Confirm
          </button>
        </form>

         {isLoading && (
              <div className='loading-login'>
            <img className='loading-login-img' src="/assets/images/l2.gif" />
          </div>
              )}

      </div>
        <span className="login-footer">
            © {new Date().getFullYear()} ProjeX. All rights reserved.
          </span>
    </div>
  );
}

export default ForgotPassword;
